import * as React from "react";
import type { SVGProps } from "react";
const SvgX02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M18 6 6 18m12 0L6 6"
    />
  </svg>
);
export default SvgX02;
